import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
export class Complainant extends Component {

    componentWillReceiveProps(props) {
        if (props.complainantObj.name === "" && props.complainantObj.phone === "" && props.complainantObj.email === "") {
            this.clearComplainant();
        }
    }

    handleComplainantChange = (changeEvent) => {
        const name = changeEvent.target.name;
        const value = changeEvent.target.value;
        this.props.complainantChanges(name, value);
    }

    handleEmailOnlyInput = (changeEvent) => {
        changeEvent.target.value = changeEvent.target.value.trim();
        this.handleComplainantChange(changeEvent);
    }

    showEmailValidationMessage = () => {
        if (this.props.emailValidationMsg.length === 0) return null;
        return <Alert ref="AlertVisible" className="alert alert-danger" dismissible="true"><ul>{this.props.emailValidationMsg.map(type => <li key={type}>{type}</li>)} </ul> </Alert>;
    }

    showCDValidationMessage = () => {
        if (this.props.validationMsgCD.length === 0) return null;
        return <Alert ref="alertVisible" className="alert alert-danger" dismissible="true"><ul>{this.props.validationMsgCD.map(type => <li key={type}>{type}</li>)}</ul> </Alert>;
    }

    clearComplainant = () => {
        this.complainantname.value = "";
        this.complainantemail.value = "";
        this.complainantphone.value = "";
    }

    render() {
        return (
            <div className="container">
                <div className="row mt-5">
                    <fieldset id="step2">
                        <legend><span className="fieldset-legend">Step 4 of 4 - Your Contact Information (Optional)</span></legend>
                        <div className="col-sm-12">
                            <h3>Complaints may be submitted anonymously. However, we ask that you provide us with your name and contact information in case we need to obtain additional details from you. Even if you provide your name and contact information, it will be kept confidential and you will not be disclosed as the source of the complaint.</h3>
                            <div className="form-group mt-2">
                                {this.showEmailValidationMessage()}
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Name">Name:</label>
                                    <div className="col-sm-4">
                                        <input className="form-control" type="text" name="name"
                                            onBlur={this.handleComplainantChange}
                                            ref={el => this.complainantname = el}
                                            minLength="3"
                                        />
                                    </div>
                                </div>
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Phone">Phone:</label>
                                    <div className="col-sm-4">
                                        <input className="form-control" type="tel" name="phone" onBlur={this.handleComplainantChange} placeholder="8880000000" title="Please enter a valid 10-digit phone number" maxLength="10" pattern="[0-9]{10}"
                                            ref={el => this.complainantphone = el}
                                        />
                                    </div>
                                </div>
                                <div className="form-horizontal row spacer">
                                    <label className="control-label col-sm-4" htmlFor="Email">Email:</label>
                                    <div className="col-sm-4">
                                        <input className="form-control" type="text" name="email" onChange={this.handleEmailOnlyInput} onBlur={this.handleComplainantChange} placeholder="name@email.com" title="Please enter a valid email address"
                                            ref={el => this.complainantemail = el}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        );
    }
}
export default Complainant;



// WEBPACK FOOTER //
// ./src/components/Complainant.js